// extracted by mini-css-extract-plugin
export default {"img":"styles_img__umriF","img-medium":"styles_img-medium__NIO+n","img-small":"styles_img-small__7uyZY"};